import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";

export const PLANITEM_PICKUP_CONTEXT = createContext();

class PlanItemPICKUPProvider extends Component {
  state = { pickup_planItems: undefined };

  unsubscribe = null;

  subscribeToBranch = () => {
    this.unsubscribe = firestore.collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
    .where("state", "==", "p")
    .onSnapshot(snapshot => {
      const containerObjs = snapshot.docs.map(doc => {
        return { id: doc.id, routingContainerState: "p", ...doc.data()};
      });

      let notInvoicedList = containerObjs.filter(function (obj) {
        return obj.invoiced !== true;
      });

      notInvoicedList.sort((a, b) => Helper.compareDateLike(a.pickUpDate, b.pickUpDate));

      this.setState({ pickup_planItems : notInvoicedList });
    });
  };

  componentDidMount = () => {
    this.subscribeToBranch();
  };

  componentDidUpdate = prevProps => {
    if ((prevProps.branchCode || "NY") !== (this.props.branchCode || "NY")) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.setState({ pickup_planItems: undefined }, this.subscribeToBranch);
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  };

  render() {
    const { pickup_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_PICKUP_CONTEXT.Provider value={pickup_planItems}>{children}</PLANITEM_PICKUP_CONTEXT.Provider>;
  }
}

export default PlanItemPICKUPProvider;

PlanItemPICKUPProvider.defaultProps = {
  branchCode: "NY",
};
